export default __webpack_public_path__ + "static/16-175bf81c1c97db16b83adcb665adaac4.png";